import React from "react";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "./_PageShell";
import RecordList from "./RecordList";

const fields = [
  { key: "name", label: "Name", type: "text", required: true, placeholder: "e.g. Acme Inc." },
  { key: "domain", label: "Website", type: "text", placeholder: "acme.com" },
  { key: "industry", label: "Industry", type: "text", placeholder: "e.g. Healthcare, Real Estate" },
  {
    key: "size",
    label: "Size",
    type: "select",
    options: ["1-10", "11-50", "51-200", "201-1000", "1001+"],
    placeholder: "Select size…",
  },
  { key: "phone", label: "Phone", type: "text", placeholder: "+91 …" },
  { key: "notes", label: "Notes", type: "textarea", placeholder: "Anything worth remembering…" },
];

export default function Companies() {
  const { workspace } = useAuth();
  const label = workspace?.labels?.company || "Company";
  return (
    <>
      <PageHeader
        eyebrow={`CRM · ${label}s`}
        title={`${label}s`}
        description="Organisations linked to your contacts and deals."
      />
      <RecordList
        endpoint="/crm/companies"
        fields={fields}
        primaryKey="name"
        secondaryKeys={["domain", "industry", "size"]}
        emptyHelp={`No ${label.toLowerCase()}s yet — add your first.`}
        newLabel={`New ${label.toLowerCase()}`}
        testIdPrefix="company"
      />
    </>
  );
}
